import {
  neutralDark,
  neutralLight,
  primaryDark,
  primaryLight,
  secondaryDark,
} from '@crehana/tailwindcss/colors';
import type { OptionTypeBase } from 'react-select';
// biome-ignore lint/style/noRestrictedImports: legacy import, will be migrated
import styled, { css } from 'styled-components';

const control = {
  borderRadius: 10,
  minHeight: 40,
  borderWidth: 1,
  borderStyle: 'solid',
  boxShadow: 'none',
};

const menu = {
  backgroundColor: 'transparent',
};

const menuList = {
  borderRadius: 10,
  padding: 0,
};

const singleValue = {
  marginLeft: 8,
};

const option = {
  padding: '12px 24px',
  backgroundColor: 'transparent',
};

const clearIndicator = {
  padding: 0,
};

const dropdownIndicator = {
  padding: '0px 16px',
};

export const lightMode = {
  control: (styles: OptionTypeBase) => ({
    ...styles,
    ...control,
    backgroundColor: neutralLight[100],
    borderColor: neutralLight[500],
    ':hover': {
      borderColor: primaryLight[500],
    },
  }),
  menu: (styles: OptionTypeBase) => ({
    ...styles,
    ...menu,
    filter:
      'drop-shadow(0px 8px 20px rgba(227, 228, 229, 0.18)) drop-shadow(0px 0px 16px rgba(187, 188, 191, 0.24))',
    boxShadow: 'none',
  }),
  menuList: (styles: OptionTypeBase) => ({
    ...styles,
    ...menuList,
    backgroundColor: neutralLight[100],
  }),
  singleValue: (styles: OptionTypeBase) => ({
    ...styles,
    ...singleValue,
    color: neutralLight[800],
  }),
  option: (styles: OptionTypeBase) => ({
    ...styles,
    ...option,
    color: neutralLight[800],
    ':hover': {
      backgroundColor: neutralLight[300],
    },
  }),
  clearIndicator: (styles: OptionTypeBase) => ({
    ...styles,
    ...clearIndicator,
    color: primaryLight[500],
  }),
  indicatorSeparator: (styles: OptionTypeBase) => ({
    ...styles,
    display: 'none',
  }),
  indicatorsContainer: (styles: OptionTypeBase) => ({
    ...styles,
    ...dropdownIndicator,
    color: primaryLight[500],
  }),
  placeholder: (styles: OptionTypeBase) => ({
    ...styles,
    paddingLeft: '8px',
  }),
};

export const darkMode = {
  control: (styles: OptionTypeBase) => ({
    ...styles,
    ...control,
    backgroundColor: neutralDark[700],
    borderColor: 'transparent',
    ':hover': {
      borderColor: primaryDark[300],
    },
  }),
  menu: (styles: OptionTypeBase) => ({
    ...styles,
    ...menu,
  }),
  menuList: (styles: OptionTypeBase) => ({
    ...styles,
    ...menuList,
    backgroundColor: neutralDark[700],
  }),
  input: (styles: OptionTypeBase) => ({
    ...styles,
    ...singleValue,
    color: neutralLight[100],
  }),
  singleValue: (styles: OptionTypeBase) => ({
    ...styles,
    ...singleValue,
    color: neutralLight[100],
  }),
  option: (styles: OptionTypeBase) => ({
    ...styles,
    ...option,
    color: neutralLight[100],
    ':hover': {
      backgroundColor: neutralDark[600],
    },
  }),
  clearIndicator: (styles: OptionTypeBase) => ({
    ...styles,
    ...clearIndicator,
    color: secondaryDark[500],
  }),
  indicatorSeparator: (styles: OptionTypeBase) => ({
    ...styles,
    display: 'none',
  }),
  indicatorsContainer: (styles: OptionTypeBase) => ({
    ...styles,
    ...dropdownIndicator,
    color: secondaryDark[500],
  }),
  placeholder: (styles: OptionTypeBase) => ({
    ...styles,
    paddingLeft: '8px',
  }),
};

export const WrapperMessages = styled.div<{ isDark?: boolean }>(
  ({ theme, isDark }) => css`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background-color: ${
      isDark ? theme.colors.base['light-dark-mode'] : theme.colors.white
    };
    padding: 24px 12px;
    color: ${
      isDark ? theme.colors.white : theme.colors.base['light-dark-mode']
    };
  `,
);
